export default __webpack_public_path__ + "static/media/screen2.f4412cff.png";